module.exports = __webpack_public_path__ + "assets/img/mecha-btn-6be26e12.png";